exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.modal-header .close[data-v-3396e912] {\n  margin-top: -20px !important;\n}\n", ""]);

// exports
